import { ButtonERP } from "@finanedi.es/storybook"
import { PerceptorGetDatosDeclaracionModelo190DtoProps } from "api/DTOs/PerceptorGetDatosDeclaracionModelo190Dto"
import { FieldErrors, UseFormSetValue } from "react-hook-form"
import { useTranslation } from "react-i18next"
import InmueblesTemplate from "./InmueblesTemplate"
import { Modelo347Form } from "../DeclaracionModelo347"

const Inmuebles347 = ({
  setValue,
  values,
  errors,
}: {
  setValue: UseFormSetValue<$TSMigrationFixMe>
  values: $TSMigrationFixMe
  errors: FieldErrors<Modelo347Form>
}) => {
  const { t } = useTranslation()
  const inmueblesCount = Array.isArray(values?.inmuebles)
    ? values.inmuebles.length
    : 0
  const handleAddInmueble = () => {
    const current = Array.isArray(values?.inmuebles) ? values.inmuebles : []
    const newInmueble = {}
    setValue("inmuebles", [...current, newInmueble], {
      shouldValidate: false,
      shouldDirty: true,
      shouldTouch: true,
    })
  }

  const handleDeleteInmueble = (index: number) => {
    const current = Array.isArray(values?.inmuebles) ? values.inmuebles : []
    const updated = current.filter(
      (_: PerceptorGetDatosDeclaracionModelo190DtoProps, idx: number) =>
        idx !== index
    )
    setValue("inmuebles", updated, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    })
  }

  return (
    <div
      title='Inmuebles'
      className='tw-w-full tw-px-4 tw-pb-4 tw-space-y-5'
    >
      <ButtonERP
        label={`${t("declaracionModelo347.addInmueble")}`}
        customize={{ type: "primary", size: "md" }}
        onClick={handleAddInmueble}
      />

      {Array.from({ length: inmueblesCount }).map((_, index) => (
        <InmueblesTemplate
          t={t}
          // eslint-disable-next-line react/no-array-index-key
          key={`inmuebles_${index}`}
          text={`${t("declaracionModelo347.inmueble")} ${index + 1}`}
          values={values}
          setValue={setValue}
          inmuebleIndex={index}
          handleDelete={() => handleDeleteInmueble(index)}
          errors={errors}
        />
      ))}
    </div>
  )
}

export default Inmuebles347
